// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hidden {
  height: 0;
  width: 0;
  margin: 0;
  padding: 0;
  opacity: 0;
  cursor: none !important;
}

.signature_border {
  border: 1px solid #000000 !important;
  margin: 1rem;
  background-color: #fff;
}
.hide {
  display: none;
}
.bg-none {
  background: transparent !important;
}
.signatureImageUpload {
  height: 320px;
  width: 100%;
}
.img_loaded {
  align-items: center;
  display: flex;
  margin: auto;
  margin-bottom: 20px;
  border: 1px solid #000000 !important;
}

.text-center p {
  display: inline-block;
  margin-left: 10px;
  vertical-align: middle;
  padding-top: 0.7rem;
  font-size: x-small;
}

img[src=''] {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/app/system-common/signature/signature.component.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,QAAQ;EACR,SAAS;EACT,UAAU;EACV,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf","sourcesContent":[".hidden {\r\n  height: 0;\r\n  width: 0;\r\n  margin: 0;\r\n  padding: 0;\r\n  opacity: 0;\r\n  cursor: none !important;\r\n}\r\n\r\n.signature_border {\r\n  border: 1px solid #000000 !important;\r\n  margin: 1rem;\r\n  background-color: #fff;\r\n}\r\n.hide {\r\n  display: none;\r\n}\r\n.bg-none {\r\n  background: transparent !important;\r\n}\r\n.signatureImageUpload {\r\n  height: 320px;\r\n  width: 100%;\r\n}\r\n.img_loaded {\r\n  align-items: center;\r\n  display: flex;\r\n  margin: auto;\r\n  margin-bottom: 20px;\r\n  border: 1px solid #000000 !important;\r\n}\r\n\r\n.text-center p {\r\n  display: inline-block;\r\n  margin-left: 10px;\r\n  vertical-align: middle;\r\n  padding-top: 0.7rem;\r\n  font-size: x-small;\r\n}\r\n\r\nimg[src=''] {\r\n  display: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
